module.exports = __webpack_public_path__ + "img/7.4a76c5f4.jpg";